import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { StackRedeployGitForm } from '@/react/portainer/gitops/StackRedeployGitForm/StackRedeployGitForm';

export const stackRedeployGitFormModule = angular
  .module('portainer.app.react.views.stack-redeploy-git-form', [])
  .component(
    'stackRedeployGitFormReact',
    r2a(withUIRouter(withReactQuery(withCurrentUser(StackRedeployGitForm))), [
      'model',
      'stack',
      'endpoint',
    ])
  ).name;
